import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';

export type JooserAvailableTimeslots = {
  [date: string]: string[];
};

type Variables = {
  id: number;
  appointmentTypeId: number;
  startDate: Date;
  endDate: Date;
};
type Response = JooserAvailableTimeslots;

export const useJooserAvailableTimeslots = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['jooser/available-timeslots'],
  fetcher: ({ id, appointmentTypeId, startDate, endDate }) => {
    return client
      .get(
        `v2/reservations/${id}/jooser/available-timeslots?appointment_type_id=${appointmentTypeId}&start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}`
      )
      .then((response) => {
        return response.data.data;
      });
  },
});
